import { Component, ElementRef, HostListener, NgZone, OnInit, Renderer2, ViewChild } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { LogHandlerService } from 'src/app/services/log-handler.service';
import { TopNavViewModel } from 'src/app/view-models/top-nav.viewmodel';
import { BaseComponent } from '../../components/base.component';

@Component({
  selector: 'app-top-nav',
  templateUrl: './top-nav.component.html',
  styleUrls: ['./top-nav.component.scss']
})
export class TopNavComponent extends BaseComponent<TopNavViewModel> implements OnInit {

  @ViewChild('stickyMenu') menuElement!: ElementRef;
  
  constructor(commonService: CommonService, logService: LogHandlerService) {
    super(commonService, logService);
    this.viewModel=new TopNavViewModel();
   }


  ngOnInit(): void {

  }


  ngAfterViewInit() {
    this.viewModel.elementPosition = this.menuElement.nativeElement.offsetTop;
  }


  @HostListener('window:scroll', ['$event'])
  handleScroll() {
    const windowScroll = window.pageYOffset;
    if (windowScroll >= this.viewModel.elementPosition) {
      this.viewModel.sticky = true;
      this.viewModel.subMenu = true;
      this.viewModel.iconView = IconVal.white;
    } else {
      this.viewModel.sticky = false;
      this.viewModel.subMenu = false;
      this.viewModel.iconView = IconVal.black;
    }

  }


  // clickEvent() {
  //   this.viewModel.status = !this.viewModel.status;
  // }

 async click_showLoginModal() {
  var x=  await this._commonService.presentLoginModal();
  this._exceptionHandler.logObject(x);
    }
}


export enum IconVal {
  black = 0, white = 1
}



